import { Button } from "antd";
import React, { Component } from "react";
import ReactHtmlTableToExcel from "react-html-table-to-excel";
import { AxiosGetSecretApi } from "../../../utils/fetchApi";
// import ChartPrint from "../../Statistic/TablePrint";
import "./bieu-do.scss";
import PieChart from "./Chart/PieQuyHoachChung";
import "../thong-ke.scss";
import StaticClass from "../../../utils/staticClass";

export default class BieuDo5000 extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dataTable: null,
      chartData: [],
    };
  }

  componentDidMount() {
    this.getAllDataTable();
  }

  ChartPrint(type) {
    var windowContent = "<!DOCTYPE html>";
    windowContent += "<html>";
    windowContent += "<head>";
    windowContent += "<title> </title>";
    windowContent +=
      '<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">';
    windowContent +=
      '<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/antd/4.8.2/antd.min.css" integrity="sha512-CPolmBEaYWn1PClN5taQQ0ucEhAt+9j7+Tiog/SblkFjZ5k6M3TioqmlpcHKwUhIcsu1s7lgnX4Plsb6T8Kq5A==" crossorigin="anonymous" />';
    windowContent += `<link href="https://fonts.googleapis.com/css?family=Roboto:400,700&display=swap&subset=vietnamese" rel="stylesheet">`;
    windowContent += `
    <style>
    .data-table {
      display: flex;
      justify-content: center;
      margin-top: 20px;
      flex-direction: row;
    }

    #chart-table {
      border-collapse: collapse;
      width: 100%;
      // max-width: 1000px;
    }

    #chart-table td,
    #chart-table th {
        border: 1px solid #ddd;
        padding: 8px;
        font-size: 15px;

    }

    #chart-table tr:nth-child(even) {
        background-color: #f2f2f2;
    }

    #chart-table th {
        text-align: left;
        background-color: white;
        color: black;
    }

    #chart-table-2 {
      border-collapse: collapse;
      width: 100%;
      // max-width: 1000px;
  }

  #chart-table-2 td,
  #chart-table-2 th {
      border: 1px solid #ddd;
      padding: 8px;
      font-size: 15px;

  }

  #chart-table-2 tr:nth-child(even) {
      background-color: #f2f2f2;
  }

  #chart-table-2 th {
      text-align: left;
      background-color: white;
      color: black;
  }
  .fl-ct{
    background: red
  }
  </style>`;

    windowContent += "</head>";
    windowContent += "<body>";

    // bieu do
    windowContent += `<div style="display: flex;justify-content: center;">`;
    windowContent += `<div style="width: 800px; margin-left: -200px;"">`;
    windowContent += document.getElementById("pie-chart").innerHTML;
    windowContent += "</div>";
    windowContent += `</div>`;

    // bang
    windowContent += `<p style="page-break-after: always;"/>`;
    windowContent += `<div style="max-width: 210mm;">`;
    windowContent += `<div style="font-size: 16px;font-weight: bold;margin: 20px 0;">Bảng thống kê tổng hợp quy hoạch phân khu 1/5000 toàn Thành phố</div>`;
    windowContent += `<table id = "chart-table">`;
    windowContent += document.getElementById(`chart-table`).innerHTML;
    windowContent += "</table>";

    windowContent +=
      '<script src="https://cdnjs.cloudflare.com/ajax/libs/antd/4.8.2/antd.min.js" integrity="sha512-oHALdU5OO+FSQGCno//1Jqi69ERPucovxrFMGZxfNvQSL4P0WVf0i9yU81gBh2RSzIebQb9NrTloSizJ7Vtpew==" crossorigin="anonymous"></script>';
    windowContent += `</div>`;
    windowContent += "</body>";
    windowContent += "</html>";
    // var printWin = window.open();
    let printWin = window.open("", "", "width=1024,height=768");
    printWin.document.open();
    printWin.document.write(windowContent);

    printWin.document.close(); // necessary for IE >= 10
    printWin.moveTo(0, 0);
    printWin.resizeTo(window.screen.width, window.screen.height);
    printWin.focus(); // necessary for IE >= 10*/
    printWin.print();
    return true;
  }

  replaceText = (text) => {
    if (text.includes("A")) return text.replaceAll("A", "");
    if (text.includes("B")) return text.replaceAll("B", "");
    if (text.includes("C")) return text.replaceAll("C", "");
  };

  addChartData(data) {
    let listColor = ["#80B1D3", "#FFFFB3", "#FB8072"];
    let chartData = [];
    let listA = [];
    let listB = [];
    let listC = [];

    data.forEach((e) => {
      if (e.STT === "A" || e.STT === "B" || e.STT === "C") {
        chartData.push({
          id: e.LoaiDat,
          label: e.LoaiDat,
          value: e.TyLe,
          color: listColor[chartData.length],
          DienTich: e.DienTich,
        });
      } else {
        if (!e.STT.includes(".")) {
          if (e.STT.includes("A")) {
            listA.push(e);
          }

          if (e.STT.includes("B")) {
            listB.push(e);
          }

          if (e.STT.includes("C")) {
            listC.push(e);
          }
        }
      }
    });

    chartData[0].listHover = listA;
    chartData[1].listHover = listB;
    chartData[2].listHover = listC;

    this.setState({
      chartData,
    });
  }

  async getAllDataTable() {
    let res = await AxiosGetSecretApi("/api/thongke/qh-phan-khu-chart");
    if (res && Array.isArray(res)) {
      // data table
      let dataTable = res.map((o, i) => {
        return (
          <tr key={i}>
            <td
              style={{
                fontWeight: `${
                  o.STT === "A" || o.STT === "B" || o.STT === "C" ? 700 : 400
                }`,
                textAlign: "left",
                paddingLeft: "10px",
              }}
            >
              {o.STT.split(".").length - 1 === 2
                ? " "
                : o.STT.length === 1
                ? o.STT
                : this.replaceText(o.STT)}
            </td>

            <td
              style={{
                textAlign: "left",
                fontWeight: `${
                  o.STT === "A" || o.STT === "B" || o.STT === "C" ? 700 : 400
                }`,
                paddingLeft:
                  o.STT.split(".").length - 1 === 2 ? "20px" : "10px",
              }}
            >
              {o.STT.split(".").length - 1 === 2 ? `+ ${o.LoaiDat}` : o.LoaiDat}
            </td>

            <td
              style={{
                textAlign: "right",
                paddingRight: "10px",
                fontWeight: `${
                  o.STT === "A" || o.STT === "B" || o.STT === "C" ? 700 : 400
                }`,
              }}
            >
              {StaticClass.formatPrice(o.DienTich)}
            </td>
            <td
              style={{
                textAlign: "right",
                paddingRight: "10px",
                fontWeight: `${
                  o.STT === "A" || o.STT === "B" || o.STT === "C" ? 700 : 400
                }`,
              }}
            >
              {StaticClass.formatPrice(o.TyLe)}
            </td>
          </tr>
        );
      });

      // pieData
      this.addChartData(res);
      this.setState({
        dataTable,
      });
    }
  }

  render() {
    return (
      <div className="bieu-do-5000 bieu-do-tong-hop">
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div id="pie-chart">
            <PieChart
              data={this.state.chartData}
              title="Biểu đồ mật độ các loại đất toàn Thành phố"
              type="QHPK"
            ></PieChart>
          </div>
        </div>

        <div
          className="thong-ke-5000"
          style={{
            paddingLeft: "10px",
            paddingRight: "10px",
            marginTop: "20px",
            marginBottom: "20px",
          }}
        >
          <p style={{ fontWeight: "bold" }}>
            Bảng thống kê tổng hợp dự án quy hoạch phân khu 1/5000 toàn Thành
            phố
          </p>

          <div>
            <div>
              <table id="chart-table" style={{ width: "100%" }}>
                <tbody>
                  <tr>
                    <th>STT</th>
                    <th>Loại đất</th>
                    <th>Diện tích (ha)</th>
                    <th>Tỷ lệ (%)</th>
                  </tr>
                  {this.state.dataTable}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div
          style={{
            display: "flex",
            marginTop: "15px",
            marginBottom: "10px",
            justifyContent: "center",
          }}
        >
          <ReactHtmlTableToExcel
            id="test-table-xls-button"
            className="ant-btn ant-btn-primary-cus"
            table="chart-table"
            filename={"Thống kê quy hoạch phân khu 1/5000"}
            sheet="tablexls"
            buttonText="Tải Excel"
          />
          <Button
            type="primary"
            className="button"
            style={{
              width: "117px",
              marginLeft: "10px",
              fontWeight: 700,
              height: "40px",
            }}
            onClick={() => this.ChartPrint("Thống kê quy hoạch phân khu 1/5000")}
          >
            In
          </Button>
        </div>
      </div>
    );
  }
}
